import React, { useState } from "react";
import "./Subordinate_Data_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { formatAmount, formatDateTimeNew } from "../../../utils/common";

function Subordinate_Data_card({ data }) {
  const [copiedIndex, setCopiedIndex] = useState(null);
  console.log({ datadatadatadatadatadatadatadatadata: data });

  const cards = [
    {
      id: 1,
      uid: "15880367",
      level: 1,
      depositAmount: 0,
      betAmount: 32,
      commission: 0.19,
      time: "2026-03-12",
    },
    {
      id: 2,
      uid: "15880368",
      level: 2,
      depositAmount: 100,
      betAmount: 50,
      commission: 1.25,
      time: "2026-03-11",
    },
  ];

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);

    setTimeout(() => {
      setCopiedIndex(null);
    }, 2000);
  };

  return (
    <section className="Withdrawal_card_holder Subordinate_Data_card">
      {data?.map((card, index) => (
        /* ---------------- OLD CARD CODE -------------------- */

        // <div className="Withdrawal_card" key={card.id}>
        //   <div className="card-top">
        //     UID : {card?.refered?.user_uid}
        //     <div
        //       className="copy-wrapper"
        //       onClick={() => handleCopy(card?.refered?.user_uid, index)}
        //     >
        //       <FontAwesomeIcon icon={faCopy} className="copy-icon" />
        //       {copiedIndex === index && (
        //         <div className="copy-tooltip">Copied!</div>
        //       )}
        //     </div>
        //   </div>

        //   <div className="card-body">
        //     {/* <div className="row-item">
        //       <span className="label">Level</span>
        //       <span className="value">{card.level}</span>
        //     </div> */}

        //     <div className="row-item">
        //       <span className="label">Deposit Amount</span>
        //       <span className="value orange">
        //         {formatAmount(card?.deposit_amount)}
        //       </span>
        //     </div>

        //     {/* <div className="row-item">
        //       <span className="label">Bet Amount</span>
        //       <span className="value orange">
        //         {" "}
        //         {formatAmount(card?.deposit_amount)}
        //       </span>
        //     </div> */}

        //     <div className="row-item">
        //       <span className="label">Reward Amount</span>
        //       <span className="value orange">
        //         {" "}
        //         {formatAmount(card?.reward_amount)}
        //       </span>
        //     </div>

        //     <div className="row-item">
        //       <span className="label">Time</span>
        //       <span className="value ">
        //         {formatDateTimeNew(card?.createdAt)}
        //       </span>
        //     </div>
        //   </div>
        // </div>
        <div className="Withdrawal_card" key={card.id}>
          <div className="card-header-custom">
            <div className="bonus-badge">
              Bonus <span className="bonus-count">{index + 1}</span>
            </div>

            <div className="uid-box">
              <div className="uid-top">
                <div
                  className="copy-wrapper"
                  onClick={() => handleCopy(card?.refered?.user_uid, index)}
                >
                  <FontAwesomeIcon icon={faCopy} className="copy-icon" />
                  {copiedIndex === index && (
                    <div className="copy-tooltip">Copied!</div>
                  )}
                </div>
              </div>

              <div className="uid-text">
                <span>UID</span>
                <strong>{card?.refered?.user_uid}</strong>
              </div>
            </div>
          </div>

          <div className="card-body">
            <div className="row-item">
              <span className="label">Deposit Amount</span>
              <span className="value orange">
                {formatAmount(card?.deposit_amount)}
              </span>
            </div>

            <div className="row-item">
              <span className="label">Reward Amount</span>
              <span className="value orange">
                {formatAmount(card?.reward_amount)}
              </span>
            </div>

            <div className="row-item">
              <span className="label">Time</span>
              <span className="value">
                {formatDateTimeNew(card?.createdAt)}
              </span>
            </div>
          </div>
          <hr className="divider" />

          <div className="status-btn">Received</div>
        </div>
      ))}
    </section>
  );
}

export default Subordinate_Data_card;
